import { useEffect, useState } from 'react';
import { useRetailerQuery } from './retailer.generated';
import { clsx } from 'clsx';
import { useParameters } from '@web/utils/src';
import { CategoryFilter } from '@/components/CategoryFilter';
import { InventoryCarousel } from '@/components/InventoryCarousel';
import { InventoryCatalog } from '@/components/InventoryCatalogue';
import { RetailerInfo } from '@/components/RetailerInfo';
import { TopInfoSearchBar } from '@/components/TopInfoSearchBar';

type RetailerParams = {
  retailerId: string;
};

const handleSearchParams = (param: string, paramValue: number | string) => {
  const url = new URL(window.location.href);

  if (!paramValue) {
    url.searchParams.delete(param);
  } else {
    url.searchParams.set(param, paramValue.toString());
  }

  const newQueryString = url.searchParams.toString();
  const newUrl =
    url.origin + url.pathname + (newQueryString ? '?' + newQueryString : '');
  window.history.pushState({}, '', newUrl);
};

const RetailerPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [category_id, setCategoryId] = useState<string | null>(null);
  const { retailerId } = useParameters<RetailerParams>();

  const handleSearchTermValue = (term: string) => {
    handleSearchParams('term', term);
    setSearchTerm(term);
  };

  const handleTaxonomyChange = (id: number) => {
    handleSearchParams('category_id', id);
    setCategoryId(`${id}`);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const term = params.get('term');
    const categoryId = params.get('category_id');
    if (term) {
      setSearchTerm(term);
    }
    if (categoryId) {
      setCategoryId(categoryId);
    }
  }, []);

  const [result] = useRetailerQuery({
    variables: {
      retailerId: retailerId,
    },
  });

  if (!result.data?.retailer) {
    return null;
  }

  return (
    <>
      <TopInfoSearchBar
        searchTerm={searchTerm}
        setSearchTerm={handleSearchTermValue}
        retailerInfo={result.data.retailer}
      />
      <div className="grid grid-cols-1 md:grid-cols-[36rem_1fr] gap-2-0">
        <div className="hidden md:block">
          <CategoryFilter
            setSelectedCategoryId={handleTaxonomyChange}
            category_id={category_id}
            className="fixed"
          />
        </div>
        <div className="py-2-0 md:py-">
          <div
            className={clsx(
              searchTerm ? 'max-h-0' : 'max-h-100-0',
              'transition-all duration-300 ease-in overflow-hidden',
            )}
          >
            <RetailerInfo retailer={result.data.retailer} />
            <InventoryCarousel />
          </div>
          {/* <InventorySorting /> */}
          <InventoryCatalog searchTerm={searchTerm} categoryId={category_id} />
        </div>
      </div>
    </>
  );
};

export default RetailerPage;
